(function (window, document, $) {

    $(document).ready(function () {

        /**
         * Update YogaTV video section to get around full-page caching
         */
        function updateYogaTvVideoContainer() {
            var utm_campaign = window.getUrlParameter('utm_campaign');

            $.ajax({
                url: themevars.ajaxurl,
                data: {
                    action: 'ym_get_video_container',
                    post_id: themevars.postID,
                    campaign: utm_campaign
                },
                type: 'POST',
                dataType: 'json'
            }).done(function (result) {

                $('[data-video-container]').html(result.data.video);

                //addVideoViewedEvent(); ErikR: this function gives an error but the PHP code for both ajax calls have been removed or turned off already so turning this function off too

                // change dnt value if cookies accepted
                if (jQuery('[data-vimeo_id]').length) {
                    let dnt = $('[data-vimeo_id]').attr('data-vimeo_dnt');

                    // Get the iframe elements
                    document.querySelectorAll('iframe').forEach(iframe => {
                        if (iframe.src.includes("vimeo")) {
                            iframe.src = iframe.src.replace("dnt=1", "dnt=" + dnt);
                        }
                    });
                }
            });
        }

        if ($('[data-video-container]').length) {
            var utm_campaign = window.getUrlParameter('utm_campaign');

            if (utm_campaign) {
                $.ajax({
                    url: themevars.ajaxurl,
                    data: {
                        action: 'check_campaign',
                        post_id: themevars.postID,
                        campaign: utm_campaign
                    },
                    type: 'POST',
                    dataType: 'json'
                }).done(function (result) {

                    if (result.data.pre_check === true) {
                        window.dispatchEvent( new Event('rmg_paywall_check_article_access') ); // trigger dap data listener
                    }
                });
            }

            // check if the paywall plugin is loaded, if not do the check right away
            if (typeof rmgPaywall !== 'undefined') {
                rmgPaywall.checkArticle(themevars.postID, {'utm_campaign': utm_campaign}, function (access, context) {
                    updateYogaTvVideoContainer();
                });
            } else {
                updateYogaTvVideoContainer();
            }
        }

        /**
         * Show subscription block if not a subscriber
         */
        function showSubscriptionBlock() {
            if ($('.video-subscription-block').length < 1) {
                return;
            }
            var postid = themevars.postID;

            $.ajax({
                url: themevars.ajaxurl,
                data: {
                    action: 'ym_get_video_subscription_block',
                    post_id: postid,
                },
                type: 'POST',
                dataType: 'json'
            }).done(function (result) {
                if (result.data.show_video_subscription_block) {
                    $('.video-subscription-block').replaceWith(result.data.show_video_subscription_block);
                    $('.video-content-sidebar .marketing-block').hide();
                }
                positionSidebar();
            });
        }

        showSubscriptionBlock();


        // add video to viewed video's list after pressing play ===============================================================
        function addVideoViewedEvent() {
            if ($('.single-video .video-header__player iframe').length < 1) {
                return;
            }

            var iframe = document.querySelector('.single-video .video-header__player iframe');
            var player = new Vimeo.Player(iframe);
            var has_played = false;

            player.on('play', function (data) {

                if (!has_played) {
                    $.ajax({
                        url: themevars.ajaxurl,
                        data: {
                            action: 'viewed_video',
                            postid: themevars.postID
                        },
                        type: 'POST',
                        dataType: 'json'
                    });

                    has_played = true;
                }
                if ($('.single-video').length){
                    $("[id^=videois]").append('has_played');
                }
            });

            var has_ended = false;
            player.on( 'ended', function() {
                if( !has_ended ) {
                    $.ajax( {
                        url      : themevars.ajaxurl,
                        data     : {
                            action : 'completed_video',
                            postid : themevars.postID
                        },
                        type     : 'POST',
                        dataType : 'json'
                    } ); 
                    
                    has_ended = true;
                    if ($('.single-video').length){
                        $("[id^=videois]").append('has_ended');
                    }
                }
            }); 
            
        }

        //addVideoViewedEvent(); ErikR: this function gives an error but the PHP code for both ajax calls have been removed or turned off already so turning this function off too
        
        // This function positions the sidebar based on window size
        function positionSidebar() {
            if(!$('body').hasClass('.single-video')) {
                return false;
            }

            if ($(window).width() < 1024) {
                if ($(".video-content-sidebar").length) {
                    $(".video-abonnement-block").insertAfter(".video-content__content");
                    $(".sidebar.videos").insertAfter(".video-content-main__comments");
                }

                if ($(".sidebar.docenten").length) {
                    $(".video-abonnement-block").insertAfter("article");
                    $(".sidebar.docenten").insertAfter(".related-content.bottom");
                }

            } else {
                if ($(".video-content-sidebar").length) {
                    $(".video-abonnement-block").appendTo("aside.video-content-sidebar");
                    $(".sidebar.videos").appendTo("aside.video-content-sidebar");
                }

                if ($(".sidebar.docenten").length) {
                    $(".video-abonnement-block").appendTo("aside");
                    $(".sidebar.docenten").appendTo("aside");
                }
            }
        }

        positionSidebar();

        $(window).on('resize', function (e) {

            if (themevars.restyling) {
                positionSidebar();
            }
        });


        // load latest and favorite video list ===============================================================
        function getVideoLists() {
            if ($('[data-load-latest-videos]').length || $('[data-load-favorite-videos]').length) {
                $.ajax({
                    url: themevars.ajaxurl,
                    data: {
                        action: 'get_video_lists',
                    },
                    type: 'POST',
                    dataType: 'json'
                }).done(function (result) {
                    $('.loading-container').remove();

                    if( $('[data-load-latest-videos-target]').length ) {
                        if (undefined === result.data.latestvideos || !result.data.latestvideos) {
                            $('[data-load-latest-videos-target]').append('<div class="filter-no-results">Hier verschijnen je laatst bekeken yogalessen.</div>');
                        } else {
                            $('[data-load-latest-videos]').removeClass('d-none');
                            $('[data-load-latest-videos-target]').append(result.data.latestvideos);
                            $(document).trigger('update-card-slider');
                        }
                    }

                    // if not logged_in show not logged in text
                    if($('[data-load-favorite-videos]').length && !result.data.logged_in) {
                        $('[data-load-favorite-videos-notloggedin]').addClass('d-block');
                        $('[data-load-favorite-videos-target]').addClass('d-none');
                    }

                    if(result.data.logged_in) {
                        // if the user has no favorite video's yet, show the no video's text
                        if (undefined === result.data.favoritevideos || result.data.no_favorite_videos_found) {
                            $('[data-load-favorite-videos-noresults]').addClass('d-block');
                            $('[data-load-favorite-videos-target]').addClass('d-none');
                        } else {  
                            // add the video's to the target element                      
                            $('[data-load-favorite-videos-target]').append(result.data.favoritevideos);
                            $(document).trigger('wpgu-set-favorites-selected');
                        }
                    }

                    if (true !== result.success) {
                        return;
                    }
                    
                    slideToHash();
                });
            }
        }
        getVideoLists();



        if ($('body.page-template-page-yogatv').length) {
            $.ajax({
                url: themevars.ajaxurl,
                data: {
                    action: 'ym_get_onboarding_data',
                    page: themevars.postID,
                },
                type: 'POST',
                dataType: 'json'
            }).done(function (result) {
                if (true !== result.success) {
                    return;
                }

                if ($('[data-yogatv-onboarding]').length && result.data.yogatv_onboarding) {
                    $('[data-yogatv-onboarding]').html(result.data.yogatv_onboarding).removeClass('d-none');
                }

                if ($('[data-yogatv-onboarding-slider]').length && result.data.yogatv_onboarding_slider) {
                    $('[data-yogatv-onboarding-slider]').html(result.data.yogatv_onboarding_slider);
                    $(document).trigger('init-onboarding-slider');
                }
            });
        }
    });

}(window, document, jQuery));
